<template>
    <Timeline>
        <TimelineItem :color="item.color" v-for="item in logs_own" :key="item.id">
            <p class="content">{{ item.content }}</p>
            <p class="time">{{ item.time }}</p>
        </TimelineItem>
    </Timeline>
</template>
<script>
export default {
  name: 'FlowLogs',
  props: ['logs'],
  data () {
    return {
      logs_own: this.logs
    }
  },
  watch: {
    logs () {
      let logsTmp = []
      this.logs.map((item, index) => {
        if (item.type === 'error') {
          item['color'] = 'red'
        } else {
          item['color'] = 'green'
        }
        logsTmp.push(item)
      })
      this.logs_own = logsTmp
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>
